import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export type TaxCertificateType = {
    name: string;
    type: string;
    base64: string;
};

export interface TaxFieldsStateType {
    readonly taxID: string;
    readonly taxCertificate: TaxCertificateType | null;
}

export type TaxFieldsState = Readonly<TaxFieldsStateType>;

const initialState: TaxFieldsState = {
    taxID: "",
    taxCertificate: null,
};

export const customTaxFieldsReducer = createTypedReducer(initialState, {
    "Custom/TaxFields/UpdateTaxCertificate": (
        draft: Draft<TaxFieldsState>,
        { taxCertificate }: { taxCertificate: { name: string; type: string; base64: string } | null },
    ) => ({
        ...draft,
        taxCertificate,
    }),

    "Custom/TaxFields/UpdateTaxID": (draft: Draft<TaxFieldsState>, { taxID }: { taxID: string }) => ({
        ...draft,
        taxID,
    }),
});
